(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Shibarium", [], factory);
	else if(typeof exports === 'object')
		exports["Shibarium"] = factory();
	else
		root["Shibarium"] = factory();
})(window, function() {
return 